/**
 * CalculatorPanel Component - MA-ARCH-161
 *
 * Calculator panel for the Quick Reference side panel. Thin wrapper around
 * the shared CalculatorKeypad (@/components/shared/CalculatorKeypad) —
 * supplies this surface's own outer container/placement/testid only. All
 * calculator behavior and the display/button-grid presentation live in the
 * shared keypad, not here.
 */

import React from 'react';
import { CardContent } from '../../../components/ui/card';
import { CalculatorKeypad } from '../../../components/shared/CalculatorKeypad';

export function CalculatorPanel() {
  return (
    <CardContent
      className="min-h-0 flex-1 overflow-y-auto pt-4"
      data-testid="quick-reference-calculator"
    >
      <CalculatorKeypad density="comfortable" />
    </CardContent>
  );
}

export default CalculatorPanel;
